import { X, Pencil } from "lucide-react";
import SearchableSelect from "../SearchableSelect";

export const inputCls = "w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none disabled:bg-slate-50 disabled:text-slate-400";

// düzeltme modu banner'ı (tüm veri giriş formlarında ortak)
export function EditBanner({ entry, onCancel, note }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap bg-sky-600 text-white rounded-md px-4 py-2.5 -mt-1" data-testid="entry-edit-banner">
      <div className="text-sm font-bold uppercase tracking-wide inline-flex items-center gap-2 flex-wrap">
        <Pencil className="w-4 h-4" /> Kayıt Düzeltiliyor — {entry.service_name}
        <span className="text-[11px] font-normal normal-case opacity-90">({entry.project_name} — {entry.location_name} — {entry.entry_date})</span>
        {note && <span className="text-[11px] font-semibold normal-case bg-white/20 rounded px-2 py-0.5" data-testid="entry-edit-note">{note}</span>}
      </div>
      <button type="button" onClick={onCancel} data-testid="entry-edit-cancel" className="inline-flex items-center gap-1 px-3 py-1 rounded-md bg-white/15 hover:bg-white/25 text-xs font-semibold"><X className="w-3.5 h-3.5" /> Vazgeç (ESC)</button>
    </div>
  );
}

// 1. Adım — Proje kutusu (boşken amber + ipucu, seçilince yeşil)
export function ProjectStep({ value, onChange, options, lock }) {
  return (
    <div className={`rounded-lg border-2 p-4 space-y-2 transition-colors ${value ? "border-emerald-300 bg-emerald-50/40" : "border-amber-400 bg-amber-50/60"}`} data-testid="entry-project-step">
      <label className="block text-sm font-bold text-slate-900 uppercase tracking-wide">1. Adım — Proje {lock ? "" : "Seçin"}</label>
      <div className="[&_input]:py-3 [&_input]:text-base [&_input]:font-semibold">
        <SearchableSelect testid="entry-project" disabled={lock} value={value} onChange={onChange} placeholder={lock ? "Yetkili olduğunuz proje yükleniyor…" : "Proje adı yazarak arayın…"} options={options} />
      </div>
      {!lock && !value && <div className="text-xs text-amber-800 font-medium" data-testid="project-first-hint">Önce proje seçin — diğer alanlar proje seçiminden sonra açılır.</div>}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      {children}
    </div>
  );
}

export function ReadonlyBox({ label, value, testid }) {
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      <div className="px-3 py-2 text-sm bg-slate-50 border border-slate-200 rounded-md text-slate-700 font-mono">{value}</div>
    </div>
  );
}

export function PreviewCard({ label, value, accent, testid }) {
  const emerald = accent === "emerald", sky = accent === "sky";
  return (
    <div className={`rounded-md border p-3 ${emerald ? "border-emerald-200 bg-emerald-50" : sky ? "border-sky-200 bg-sky-50" : "border-slate-200 bg-slate-50"}`} data-testid={testid}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className={`mt-1 text-lg font-mono font-bold ${emerald ? "text-emerald-700" : sky ? "text-sky-800" : "text-slate-900"}`}>{value}</div>
    </div>
  );
}
